module.exports = __webpack_public_path__ + "static/media/119-brunei.62726de2.svg";